import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { UserDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getByEmailByEmail = (email: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserDto>({
      method: 'GET',
      url: '/api/app/user/by-email',
      params: { email },
    },
    { apiName: this.apiName,...config });
}